import * as React from 'react';

export interface ILocationSectionBodyProps extends React.PropsWithChildren {}

export const LocationSectionBody: React.FunctionComponent<
  ILocationSectionBodyProps
> = props => {
  return (
    <div className='col-span-6 max-w-3xl md:col-span-4'>{props.children}</div>
  );
};
